// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"d835d1e0","421":"645821a2","496":"ec5bd10f","514":"765c36b7","663":"2428d260","674":"52b9ffa7","787":"2d499073"}[chunkId] + ".chunk.js";
};